import web from './web'

/*
  web,
  rerport,
*/

export default {
  ...web
}
